import {
	Http,
	Response
}						  from '@angular/http';
import {
  Inject,
  Injectable
}             from '@angular/core';

export interface HTTPCallback { (data: any): void }

@Injectable()
export class UtilityService {
  constructor(private http: Http) {
    console.log('Utility service created');
  }

  getLocalStorageArray(key: string): any[] {
    var data: any[] = JSON.parse(localStorage.getItem(key));

    if (Array.isArray(data)) {
      return data;
    } else {
      this.setLocalStorageData(key, []);

      return [];
    }
  }

  getLocalStorageString(key: string): string {
    var data: string = localStorage.getItem(key);

    if (typeof data === 'string') {
      return data;
    } else {
      this.setLocalStorageData(key, '');

      return '';
    }
  }

  httpGet(url: string, callback: HTTPCallback, context: any, headers: any = {}): void {
    this.http.get(url, <any>{ headers: headers }).take(1).subscribe(response => {
      callback.call(context, response.json())
    }, response => {
      console.log(response);
      
      callback(response.json);
    });
	}

	httpPost(
    url:        string,
    parameters: any,
    callback:   HTTPCallback,
    context:    any,
    headers:    any = {}
  ): void {
    this.http.post(url, parameters, <any>{ headers: headers }).take(1).subscribe(response => {
      callback.call(context, response.json())
    }, response => {
      console.log(response);
      
      callback(response.json);
    });
	}

  injectScript(source: string, key: string, callback: (data: any) => void, context: any): void {
    let script = document.createElement('script');

    script.src = source;
    script.type = 'text/javascript';

    let interval = setInterval(() => {
      let value = <any>window[key];

      if (typeof value !== 'undefined') {
        clearInterval(interval);

        callback.call(context, value);
      }
    }, 50);

		document.body.appendChild(script);
  }

  openUrl(url: string): boolean {
		if (url.length > 0) {
			console.log(window.open(url, '_blank'));

      return true;
		} else {
      console.log('Url is an empty string');
    }

    return false;
	}

  setLocalStorageData(key: string, data: any): void {
    if (typeof data === 'string') {
      localStorage.setItem(key, data);
    } else {
      localStorage.setItem(key, JSON.stringify(data));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/utility.service.ts